export const DEFAULT = 'DEFAULT';
export const SELECTED = 'SELECTED';
export const DISABLED = 'DISABLED';
